module.exports = __webpack_public_path__ + "static/media/number02.5b408880.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/number02.svg
// module id = 928
// module chunks = 0